/* tslint:disable:no-any */
export namespace CommunicationColors {
  export const shade30 = '#004578';
  export const shade20 = '#005a9e';
  export const shade10 = '#106ebe';
  export const primary = '#0078d4';
  export const tint10 = '#2b88d8';
  export const tint20 = '#c7e0f4';
  export const tint30 = '#deecf9';
  export const tint40 = '#eff6fc';
}

export namespace NeutralColors {
  export const black = '#000000';
  export const gray220 = '#11100f';
  export const gray210 = '#161514';
  export const gray200 = '#1b1a19';
  export const gray190 = '#201f1e';
  export const gray180 = '#252423';
  export const gray170 = '#292827';
  export const gray160 = '#323130';
  export const gray150 = '#3b3a39';
  export const gray140 = '#484644';
  export const gray130 = '#605e5c';
  export const gray120 = '#797775';
  export const gray110 = '#8a8886';
  export const gray100 = '#979593';
  export const gray90 = '#a19f9d';
  export const gray80 = '#b3b0ad';
  export const gray70 = '#bebbb8';
  export const gray60 = '#c8c6c4';
  export const gray50 = '#d2d0ce';
  export const gray40 = '#e1dfdd';
  export const gray30 = '#edebe9';
  export const gray20 = '#f3f2f1';
  export const gray10 = '#faf9f8';
  export const white = '#ffffff';
}

export namespace SharedColors {
  export const pinkRed10 = '#750b1c';
  export const red20 = '#a4262c';
  export const red10 = '#d13438';
  export const redOrange20 = '#603d30';
  export const redOrange10 = '#da3b01';
  export const orange30 = '#8e562e';
  export const orange20 = '#ca5010';
  export const orange10 = '#ffaa44';
  export const yellow10 = '#fce100';
  export const orangeYellow20 = '#986f0b';
  export const orangeYellow10 = '#c19c00';
  export const yellowGreen10 = '#8cbd18';
  export const green20 = '#0b6a0b';
  export const green10 = '#498205';
  export const greenCyan10 = '#00ad56';
  export const cyan40 = '#005e50';
  export const cyan30 = '#005b70';
  export const cyan20 = '#038387';
  export const cyan10 = '#00b7c3';
  export const cyanBlue20 = '#004e8c';
  export const cyanBlue10 = '#0078d4';
  export const blue10 = '#4f6bed';
  export const blueMagenta40 = '#373277';
  export const blueMagenta30 = '#5c2e91';
  export const blueMagenta20 = '#8764b8';
  export const blueMagenta10 = '#8378de';
  export const magenta20 = '#881798';
  export const magenta10 = '#c239b3';
  export const magentaPink20 = '#9b0062';
  export const magentaPink10 = '#e3008c';
  export const gray40 = '#393939';
  export const gray30 = '#7a7574';
  export const gray20 = '#69797e';
  export const gray10 = '#a0aeb2';
}
